import {
  isArray as p,
  isDate as Nt,
  isObject as yt,
  keys as or
} from "./code-utils.js";
import { getByteLength as U } from "./string-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { toValidBackendTimeString as Ft } from "./date-utils.js";
import { BRAZE_ACTIONS as P } from "./braze-actions.js";
import { SET_CUSTOM_USER_ATTRIBUTE_STRING as Ut } from "../common/constants.js";
export const CUSTOM_DATA_REGEX = /^[^\x00-\x1F\x22]+$/;
export const CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX = /[$.]/;
export const CUSTOM_ATTRIBUTE_RESERVED_OPERATORS = [
  "$add",
  "$update",
  "$remove",
  "$identifier_key",
  "$identifier_value",
  "$new_object",
  "$time"
];
export const EMAIL_ADDRESS_REGEX = new RegExp(/^.+@.+\..+$/);
export const CUSTOM_PROPERTIES_MAX_SIZE_BYTES = 51200;
export const CUSTOM_PROPERTIES_MAX_SIZE_STRING = "50KB";
export const CUSTOM_ATTRIBUTES_MAX_SIZE_BYTES = 76800;
export const CUSTOM_ATTRIBUTES_MAX_SIZE_STRING = "75KB";
export const CUSTOM_ATTRIBUTE_MAX_DEPTH = 50;
export const BRAZE_ACTION_URI_REGEX = /^brazeActions:\/\/v\d+\//;
export function validateCustomString(t, e, n) {
  const o =
    null != t &&
    "string" == typeof t &&
    ("" === t || t.match(CUSTOM_DATA_REGEX));
  return o || r.D.error(`Cannot ${e} because ${n} "${t}" is invalid.`), o;
}
export function validateCustomAttributeKey(t) {
  return (
    null != t &&
      t.match(CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX) &&
      -1 === CUSTOM_ATTRIBUTE_RESERVED_OPERATORS.indexOf(t) &&
      r.D.warn("Custom attribute keys cannot contain '$' or '.'"),
    validateCustomString(t, "set custom user attribute", "the given key")
  );
}
export function validatePropertyType(t) {
  const e = typeof t;
  return (
    null == t || "number" === e || "boolean" === e || Nt(t) || "string" === e
  );
}
export function _validateNestedProperties(t, e, n) {
  const o = -1 !== n;
  if (o && n > 50)
    return (
      r.D.error("Nested attributes cannot be more than 50 levels deep."), !1
    );
  const i = o ? n + 1 : -1;
  if (p(t) && p(e)) {
    for (let r = 0; r < t.length && r < e.length; r++)
      if (
        (Nt(t[r]) && (e[r] = Ft(t[r])),
        !_validateNestedProperties(t[r], e[r], i))
      )
        return !1;
  } else {
    if (!yt(t)) return validatePropertyType(t);
    for (const r of or(t)) {
      if (o && !validateCustomAttributeKey(r)) return !1;
      if (
        (Nt(t[r]) && (e[r] = Ft(t[r])),
        !_validateNestedProperties(t[r], e[r], i))
      )
        return !1;
    }
  }
  return !0;
}
export function _validateEventPropertyValue(t, e, n, o, i) {
  let a;
  return (
    (a =
      yt(t) || p(t)
        ? _validateNestedProperties(t, e, i ? 1 : -1)
        : validatePropertyType(t)),
    a || r.D.error(`Cannot ${n} because ${o} "${t}" is invalid.`),
    a
  );
}
export function validateStandardString(t, e, n, o) {
  const i = "string" == typeof t || (null === t && o);
  return i || r.D.error(`Cannot ${e} because ${n} "${t}" is invalid.`), i;
}
export function validateCustomProperties(t, e, n, o, i) {
  if ((null == t && (t = {}), "object" != typeof t || p(t)))
    return (
      r.D.error(`${e} requires that ${n} be an object. Ignoring ${i}.`),
      [!1, null]
    );
  let a, s;
  e === Ut ? ((a = 76800), (s = "75KB")) : ((a = 51200), (s = "50KB"));
  const u = JSON.stringify(t);
  if (U(u) > a)
    return (
      r.D.error(
        `Could not ${o} because ${n} was greater than the max size of ${s}.`
      ),
      [!1, null]
    );
  let l;
  try {
    l = JSON.parse(u);
  } catch (t) {
    return (
      r.D.error(`Could not ${o} because ${n} did not contain valid JSON.`),
      [!1, null]
    );
  }
  for (let r in t) {
    if (e === Ut && !validateCustomAttributeKey(r)) return [!1, null];
    if (!validateCustomString(r, o, `the ${i} property name`))
      return [!1, null];
    const n = t[r];
    if (e !== Ut && null == n) {
      delete t[r], delete l[r];
      continue;
    }
    Nt(n) && (l[r] = Ft(n));
    if (
      !_validateEventPropertyValue(
        n,
        l[r],
        o,
        `the ${i} property "${r}"`,
        e === Ut
      )
    )
      return [!1, null];
  }
  return [!0, l];
}
export function validateCustomAttributeArrayType(t, e) {
  let n = !1,
    o = !1;
  const i = () => {
    r.D.error(
      "Custom attribute arrays must be either string arrays or object arrays."
    );
  };
  for (const r of e)
    if ("string" == typeof r) {
      if (o) return i(), [!1, !1];
      if (
        !validateCustomString(
          r,
          `set custom user attribute "${t}"`,
          "the element in the given array"
        )
      )
        return [!1, !1];
      n = !0;
    } else {
      if (!yt(r)) return i(), [!1, !1];
      if (n) return i(), [!1, !1];
      if (
        !validateCustomProperties(
          r,
          Ut,
          "attribute value",
          `set custom user attribute "${t}"`,
          "custom user attribute"
        )
      )
        return [!1, !1];
      o = !0;
    }
  return [n, o];
}
export function isValidEmail(t) {
  return (
    "string" == typeof t && null != t.toLowerCase().match(EMAIL_ADDRESS_REGEX)
  );
}
export function isValidBrazeActionJson(t) {
  if (!(P.properties.type in t)) return !1;
  switch (t[P.properties.type]) {
    case P.types.ue:
      if (P.properties.me in t) return !0;
      break;
    case P.types.logCustomEvent:
    case P.types.setEmailNotificationSubscriptionType:
    case P.types.setPushNotificationSubscriptionType:
    case P.types.setCustomUserAttribute:
    case P.types.addToSubscriptionGroup:
    case P.types.removeFromSubscriptionGroup:
    case P.types.addToCustomAttributeArray:
    case P.types.removeFromCustomAttributeArray:
    case P.types.de:
    case P.types.pe:
      if (P.properties.fe in t) return !0;
      break;
    case P.types.requestPushPermission:
      return !0;
    default:
      return !1;
  }
  return !1;
}
export function isValidBrazeActionType(t) {
  let e = !1;
  return (
    Object.keys(P.types).forEach(r => {
      P.types[r] !== t.toString() || (e = !0);
    }),
    e
  );
}
